import { DOCUMENT } from '@angular/common'
import { Inject, Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { fromEvent, of, Subject } from 'rxjs'
import { delay, repeatWhen, takeUntil } from 'rxjs/operators'

export const INACTIVE_TIMER = 1000 * 60 * 10 // 10 minutes

@Injectable({
  providedIn: 'root',
})
export class InactiveService {
  /** @internal */
  readonly start$ = new Subject<void>()

  readonly isVisible$ = new Subject<boolean>()

  visibilityChangeIndicator = of(true).pipe(
    // Stops the timer
    takeUntil(this.isVisible$),
    // Starts the timer
    repeatWhen(() => this.start$),
    // And finally, delay the timer, so the subscribers don't get called immediately
    delay(INACTIVE_TIMER),
  )

  constructor(
    @Inject(DOCUMENT) private readonly document: Document,
    private readonly router: Router,
  ) {}

  init() {
    if (this.router.url.includes('/inactive')) {
      return // Ignore redirecting again
    }

    fromEvent(window, 'focus').subscribe(() => this.isVisible$.next(true))

    fromEvent(window, 'blur').subscribe(() => {
      this.start$.next()
      this.isVisible$.next(false)
    })

    fromEvent(this.document, 'visibilitychange').subscribe(() => {
      const isVisible = this.isWindowVisible()
      this.isVisible$.next(isVisible)
      if (!isVisible) {
        this.start$.next()
      }
    })

    // this.visibilityChangeIndicator.subscribe(() => {
    //   if (this.router.url.includes('/inactive')) {
    //     return
    //   }

    //   this.router.navigate(['/inactive'], {
    //     queryParams: {
    //       redirect: window.location.pathname,
    //     },
    //   })
    // })
  }

  isWindowVisible() {
    return !this.document.hidden
  }
}
